import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusmenu'
})
export class StatusPipe implements PipeTransform {
  transform(value: number): string {
    if(value == 0){
        return "Disponible";
    }else{
      return "En ruta";
    }
  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/statusMenu.pipe.ts